<template>
  <div class="content-box">
    <div class="page-title">
      当前位置：首页 > 项目展示
    </div>
    <div class="content-info">
      <h3 class="form-title flex-center">
        项目展示
      </h3>
      <div class="form-step flex-center ">
        <span class="margin-right" :class="curIndex == 0 ? 'active' :'' " @click="curIndex =0 ">第一步：机构信息</span>
        <span :class="curIndex == 1 ? 'active' :'' " @click="curIndex =1 ">第二步：项目信息</span>
      </div>
      <div class="step-box"  v-if="curIndex == 0">
        <div class="step-title">
          <div class="step-title-text">
            1.基本信息
          </div>
        </div>
        <div class="padding">
          <el-form ref="importInfo" :model="importInfo" label-width="200px">

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="机构名称：" class="margin-bottom-sm">
                  <el-input v-model="name" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="机构类型：" class="margin-bottom-sm" prop="org_type">
                  <div class="input-container active">
                    <el-radio-group v-model="importInfo.org_type" :max="1" disabled>
                      <el-radio label="社会团体" name="type"></el-radio>
                      <el-radio label="社会服务机构" name="type"></el-radio>
                      <el-radio label="基金会" name="type"></el-radio>
                    </el-radio-group>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="注册地址：" class="margin-bottom-sm">
                  <el-input v-model="address" disabled></el-input>
                </el-form-item>
              </el-col>
<!--              <el-col :span="6">-->
<!--                <el-form-item label="登记证号：" class="margin-bottom-sm" label-width="90px">-->
<!--                  <el-input v-model="regist_no" disabled></el-input>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
              <el-col :span="12">
                <el-form-item label="登记时间：" class="margin-bottom-sm">
                  <el-input v-model="chengli_time" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="联系人：" class="margin-bottom-sm">
                  <el-input v-model="contacts" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话：" class="margin-bottom-sm">
                  <el-input v-model="phone" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="电子邮箱：" class="margin-bottom-sm">
                  <el-input v-model="email" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="机构网站：" class="margin-bottom-sm">
                  <el-input v-model="website" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="登记管理机关：" class="margin-bottom-sm">
                  <el-input v-model="administration" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="业务主管/指导单位：" class="margin-bottom-sm">
                  <el-input v-model="business_unit" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="社会组织评估等级：" class="margin-bottom-sm">
                  <el-input v-model="importInfo.level" placeholder="（如还未参与评估，可不填）" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="等级评估有效期截止时间：" class="margin-bottom-sm">
                  <el-input v-model="importInfo.end_time" placeholder="（如还未参与评估，可不填）" disabled></el-input>
                  <!--<el-date-picker-->
                  <!--v-model="importInfo.end_time"-->
                  <!--type="date"-->
                  <!--format="yyyy 年 MM 月 dd 日"-->
                  <!--value-format="yyyy-MM-dd"-->
                  <!--placeholder="（如还未参与评估，可不填）">-->
                  <!--</el-date-picker>-->
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="法人代表：" class="margin-bottom-sm">
                  <el-input v-model="legal_person" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话：" class="margin-bottom-sm" prop="shenbao_phone">
                  <el-input v-model="importInfo.shenbao_phone" placeholder="请输入电话号码" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="2019年资产总额：" class="margin-bottom-sm" prop="assets">
                  <el-input v-model="importInfo.assets" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="2019年总支出：" class="margin-bottom-sm" prop="expenditure">
                  <el-input v-model="importInfo.expenditure" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="机构领域（可多选）：" class="margin-bottom-sm" prop="range">
              <div class="input-container active">
                <el-checkbox-group v-model="importInfo.range" disabled>
                  <el-checkbox label="扶贫" name="area"></el-checkbox>
                  <el-checkbox label="济困" name="area"></el-checkbox>
                  <el-checkbox label="扶老" name="area"></el-checkbox>
                  <el-checkbox label="救孤" name="area"></el-checkbox>
                  <el-checkbox label="恤病" name="area"></el-checkbox>
                  <el-checkbox label="助残" name="area"></el-checkbox>
                  <el-checkbox label="救灾" name="area"></el-checkbox>
                  <el-checkbox label="助医" name="area"></el-checkbox>
                  <el-checkbox label="助学" name="area"></el-checkbox>
                  <el-checkbox label="环境保护" name="area"></el-checkbox>
                  <el-checkbox label="社区治理与营造" name="area"></el-checkbox>
                  <el-checkbox label="会员服务" name="area"></el-checkbox>
                  <!--                  <el-checkbox label="疫情防控、复工复产" name="area"></el-checkbox>-->
                  <el-checkbox label="行业协调" name="area"></el-checkbox>
                  <el-checkbox label="行业自律" name="area"></el-checkbox>

                  <el-checkbox label="行业服务" name="area"></el-checkbox>
                  <el-checkbox label="其他" name="area">其他
                    <el-input v-model="areaother" v-if="importInfo.range.indexOf('其他')!==-1" class="input-type"
                              size="mini" placeholder="请填写"></el-input>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>

            <el-form-item label="信用状况（2017-2019）：" class="margin-bottom-xs" prop="sx">
              <div class="xy-box">
                <div class="xy-item active">
                  <div>机构或机构负责人存在失信行为</div>
                  <el-radio-group v-model="importInfo.is_dishonesty" disabled>
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </div>
                <div class="xy-item active">
                  <div>机构受到登记管理机关或其他部门行政处罚或行政处罚尚未执行完毕</div>
                  <el-radio-group v-model="importInfo.is_punish" disabled>
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </div>
                <div class="xy-item">
                  <div>机构或机构负责人正在被司法机关或有关部门立案调查</div>
                  <el-radio-group v-model="importInfo.is_investigation" disabled>
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </el-form-item>
          </el-form>
          <div class="file-tip">附件：请附电子版法人登记证书，如已参加等级评估，请附等级评估证书。</div>
          <div class="file-box">
            <div class="file-container">
              <div class="file-title"><span>* </span>电子法人登记证书：</div>
              <div class="file-img-container iconfont" v-if="legal_person_img">
                <el-image
                  style="width: 183px; height: 130px"
                  :src="legal_person_img"
                  :preview-src-list="[legal_person_img]">
                </el-image>
              </div>
            </div>
            <div class="file-container">
              <div class="file-title"> 等级评估证书：</div>
              <div class="file-img-container iconfont" v-if="level_img">
                <el-image
                  style="width: 183px; height: 130px"
                  :src="level_img"
                  :preview-src-list="[level_img]">
                </el-image>
              </div>
            </div>
          </div>

        </div>

        <div class="step-title flex-center">
          <div class="step-title-text">
            2.荣誉表彰
          </div>
        </div>
        <div class="padding">
          <el-row :gutter="30">
            <el-col :span="24" v-for="(item,index) in ryArr" :key="index">
              <div class="demeanour-item ">
                <el-row :gutter="30">
                  <el-col :span="16">
                    <div class="flex-start"><span>获奖时间:</span>
                      <p>{{ item.winning_time}}</p></div>
                    <div class="flex-start"><span>荣誉名称:</span>
                      <p>{{ item.honor_name }}</p></div>
                    <div class="flex-start"><span>颁发单位:</span>
                      <p>{{ item.issued_unit }}</p>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div><span>证明资料：</span><img :src="item.prove_material" alt=""></div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>

        </div>

        <div class="operate">
          <el-button class="operate-next" @click="next()">下一步</el-button>
        </div>




      </div>
      <div class="step-box" v-if="curIndex == 1">
        <div class="step-title">
          <div class="step-title-text">
            1.项目信息
          </div>
        </div>
        <div class="padding">
          <el-form ref="importInfo" :model="importInfo" label-width="170px">
            <el-form-item label="项目名称：" class="margin-bottom-sm" prop="entry_name">
              <el-input v-model="importInfo.entry_name" placeholder="请输入项目名称" disabled></el-input>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="服务对象：" class="margin-bottom-sm" prop="service_object">
                  <el-input v-model="importInfo.service_object" placeholder="请输入服务对象" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="服务地点：" class="margin-bottom-sm" prop="service_address">
                  <el-input v-model="importInfo.service_address" placeholder="请输入服务地点" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="服务领域（可多选）：" class="margin-bottom-sm" prop="service_lingyu">
              <div class="input-container active" >
                <el-checkbox-group v-model="importInfo.service_lingyu" disabled>
                  <el-checkbox label="扶贫" name="area"></el-checkbox>
                  <el-checkbox label="济困" name="area"></el-checkbox>
                  <el-checkbox label="扶老" name="area"></el-checkbox>
                  <el-checkbox label="救孤" name="area"></el-checkbox>
                  <el-checkbox label="恤病" name="area"></el-checkbox>
                  <el-checkbox label="助残" name="area"></el-checkbox>
                  <el-checkbox label="救灾" name="area"></el-checkbox>
                  <el-checkbox label="助医" name="area"></el-checkbox>
                  <el-checkbox label="助学" name="area"></el-checkbox>
                  <el-checkbox label="环境保护" name="area"></el-checkbox>
                  <el-checkbox label="社区治理与营造" name="area"></el-checkbox>
                  <el-checkbox label="会员服务" name="area"></el-checkbox>
                  <el-checkbox label="行业协调" name="area"></el-checkbox>
                  <el-checkbox label="行业自律" name="area"></el-checkbox>
                  <el-checkbox label="行业服务" name="area"></el-checkbox>
                  <el-checkbox label="疫情防控、复工复产" name="area"></el-checkbox>
                  <el-checkbox label="党群服务" name="area"></el-checkbox>
                  <el-checkbox label="社会心理" name="area"></el-checkbox>
                  <el-checkbox label="科技创新" name="area"></el-checkbox>
                  <el-checkbox label="对外交流" name="area"></el-checkbox>
                  <el-checkbox label="文化建设" name="area"></el-checkbox>
                  <el-checkbox label="调查研究" name="area"></el-checkbox>
                  <el-checkbox label="其他" name="area">其他
                    <el-input v-model="areaother1" v-if="importInfo.service_lingyu.indexOf('其他')!==-1" class="input-type"
                              size="mini" placeholder="请填写" disabled></el-input>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>
            <el-form-item label="运作经验：" class="margin-bottom-sm" prop="experience">
              <div class="input-container active">
                <span>该项目</span>
                <el-radio-group v-model="importInfo.experience" :max="1" disabled >
                  <el-radio label="新设立但有基础" name="type"></el-radio>
                  <el-radio label="开展1年以下" name="type"></el-radio>
                  <el-radio label="开展1-2年" name="type"></el-radio>
                  <el-radio label="开展3年以上" name="type"></el-radio>
<!--                  <el-radio label="其他" name="type">其他-->
<!--                    <el-input v-if="importInfo.experience === '其他'" class="input-type" size="mini" v-model="jyother"-->
<!--                              placeholder="请填写" disabled></el-input>-->
<!--                  </el-radio>-->
                </el-radio-group>
              </div>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="经费预算：" class="margin-bottom-sm" prop="yusuan">
                  <div class="input-container">
                    <el-input v-model="importInfo.yusuan" placeholder="请输入金额" disabled></el-input>
                    <span style="padding-left: 10px;">万元/年</span>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="以往资金来源：" class="margin-bottom-sm" prop="source">
              <el-input type="textarea" :rows="3" resize="none" v-model="importInfo.source"
                        placeholder="请填写以往项目资金来源单位或渠道" disabled></el-input>
            </el-form-item>
            <el-form-item label="服务地区：" class="margin-bottom-sm" prop="service_area">
              <el-input v-model="importInfo.service_area" placeholder="该项目拟开展的地区（可精确到区、街道或社区）。" disabled></el-input>
            </el-form-item>
            <el-form-item label="项目团队：" class="margin-bottom-sm" prop="team">
              <el-input type="textarea" :rows="3" resize="none" v-model="importInfo.team"
                        placeholder="请列明直接参与该项目的工作人员，能力状况，是否专职等信息" disabled></el-input>
            </el-form-item>
            <el-form-item label="项目简介：" class="margin-bottom-sm" prop="xiangmu_desc">
              <el-input type="textarea" :rows="9" resize="none" v-model="importInfo.xiangmu_desc"
                        placeholder="简介写作内容请说明以下方面的内容：
1.项目针对的社区需求/社会问题
2.项目对该问题/需求的解决策略
3.项目的主要内容/活动
4.项目的服务成效
5.项目的社会影响
6.项目的推广性（项目特别适用于在哪些地域/社区开展、与哪些部门/单位合作？）
7.项目特色或亮点" disabled></el-input>
            </el-form-item>
          </el-form>
          <div class="file-tip">附件上传</div>
          <div class="file-container">
            <div class="file-title"><span>* </span>项目开展的照片3-5张：</div>
            <div class="file-img-container iconfont" v-for="(item,index) in xiangmu_kaizhan_img" :key="index">
              <el-image
                style="width: 183px; height: 130px"
                :src="item"
                :preview-src-list="xiangmu_kaizhan_img">
              </el-image>
            </div>
          </div>
          <div class="file-container">
            <div class="file-title">项目服务的案例1-2个：</div>
            <div class="file-img-container iconfont">
              <div v-for="(item,index) in xiangmu_service_img" :key="index">
                <p style="position: relative;padding: 15px;border: 1px solid #f9aa0d;margin-bottom: 10px;">
                  <a :href="item[0]" target="_blank" style="height: 30px;display: flex;align-items: center;">
                    <img src="../../assets/img/word.png" alt="" width="22px;">{{ item[0] }}
                  </a>
                  <a :href="item[1]" target="_blank" style="height: 30px;display: flex;align-items: center;">
                    <img src="../../assets/img/pdf.png" alt="" width="22px;">{{ item[1] }}
                  </a>
                </p>
              </div>

            </div>
          </div>
          <div class="file-container">
            <div class="file-title">其他资料：</div>
            <div class="file-img-container iconfont" v-if="qita">
              <el-image
                style="width: 183px; height: 130px"
                :src="qita"
                :preview-src-list="[qita]">
              </el-image>
            </div>
          </div>
        </div>
        <div class="step-title" style="padding: 20px 0">
          <div class="step-title-text">
            2.承诺函
          </div>
        </div>
        <div class="promise">
          <el-checkbox :value="checked" >
            <span style="font-size: 16px">本单位承诺，所有展示提交的资料内容真实有效。</span>
          </el-checkbox>
          <p>单位：{{ name }}</p>
          <p>日期：{{ update_time }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "projectDetail",
    components: {
    },
    data() {
      return {
        curIndex:0,
        id: 0,
        importInfo: {
          org_type: '',
          range: [],
          shenbao_phone: '',
          assets: '',
          expenditure: '',
          level: '',
          end_time: '',
          is_dishonesty: '',
          is_punish: '',
          is_investigation: '',

          entry_name: '',
          service_object: '',
          service_address: '',
          service_lingyu: [],
          experience: '',
          yusuan: '',
          source: '',
          service_area: '',
          team: '',
          xiangmu_desc: '',
        },
        ryArr: [],     //  荣誉
        name: '',
        address: '',
        regist_no: '',
        chengli_time: '',
        legal_person: '',
        contacts: '',
        phone: '',
        email: '',
        website: '',
        administration: '',
        business_unit: '',
        areaother: '',
        legal_person_img: '',
        level_img: '',
        areaother1: '',
        jyother: '',
        xiangmu_kaizhan_img: [],
        xiangmu_service_img: [],
        qita: '',
        update_time:'',
        checked:true
      }
    },
    created() {
      this.id = this.$route.query.id ? this.$route.query.id : 0
      this.$emit('setIndex', 2)
      this.init()
      this.getHonorList()
    },
    methods: {
      /*
      * 获取荣誉列表
      * */
      getHonorList(){
        this.$api.apiContent.getHonorList({
          token: this.$store.state.user.token
        }).then(res => {
          console.log(res)
          this.ryArr = res.data?res.data:[]
        }).catch(e => {
          this.$message.error(e.msg)
        })
      },
      next() {
        this.curIndex=1
      },
      init() {
        this.$api.apiContent.getBaseinfoSave({
          token: this.$store.state.user.token,
        }).then(res => {
          this.name = res.data.name
          this.address = res.data.address
          this.regist_no = res.data.regist_no
          this.chengli_time = res.data.chengli_time
          this.legal_person = res.data.legal_person
          this.contacts = res.data.contacts
          this.phone = res.data.phone
          this.email = res.data.email
          this.website = res.data.website
          this.administration = res.data.administration
          this.business_unit = res.data.business_unit

          this.importInfo.type = res.data.org_type
          if (res.data.range){
            let range = res.data.range.split(',')
            if (range.indexOf('其他') !== -1){
              this.importInfo.range = range.splice(0,range.length-1)
              this.areaother =range[range.length-1]
            }else{
              this.importInfo.range = range
            }
          }
          this.importInfo.org_type = res.data.org_type
          this.importInfo.assets = res.data.assets
          this.importInfo.shenbao_phone = res.data.shenbao_phone
          this.importInfo.expenditure = res.data.expenditure
          this.importInfo.level = res.data.level
          this.importInfo.end_time = res.data.end_time?res.data.end_time:''
          this.importInfo.is_dishonesty = res.data.is_dishonesty
          this.importInfo.is_punish = res.data.is_punish
          this.importInfo.is_investigation = res.data.is_investigation

          this.level_img = res.data.level_img
          this.legal_person_img = res.data.legal_person_img
        }).catch(() => {
        })

        this.$api.apiContent.projectInfo({
          token: this.$store.state.user.token,
          apply_id: this.id
        }).then(res => {
          this.xiangmu_kaizhan_img = res.data.xiangmu_kaizhan_img ? res.data.xiangmu_kaizhan_img.split(','):[]
          this.xiangmu_service_img = res.data.xiangmu_service_img? res.data.xiangmu_service_img : []
          this.qita = res.data.qita

          if (res.data.service_lingyu) {
            let range = res.data.service_lingyu.split(',')
            if (range.indexOf('其他') !== -1) {
              this.importInfo.service_lingyu = range.splice(0, range.length - 1)
              this.areaother1 = range[range.length - 1]
            } else {
              this.importInfo.service_lingyu = range
            }
          }
          this.importInfo.entry_name = res.data.entry_name
          this.importInfo.service_object = res.data.service_object
          this.importInfo.service_address = res.data.service_address
          if (res.data.experience) {
            let experience = res.data.experience.split(',')
            if (experience.indexOf('其他') !== -1) {
              this.importInfo.experience = experience[0]
              this.jyother = experience[1]
            } else {
              this.importInfo.experience = experience[0]
            }
          }
          this.update_time = res.data.update_time.slice(0,11)
          this.importInfo.yusuan = res.data.yusuan
          this.importInfo.source = res.data.source
          this.importInfo.service_area = res.data.service_area
          this.importInfo.team = res.data.team
          this.importInfo.xiangmu_desc = res.data.xiangmu_desc

        }).catch(() => {
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .content-info {
    .form-title {
      height: 56px;
      padding: 0 30px;
      border-bottom: 2px solid #f2f2f2;
      position: relative;
      font-size: 18px;

      &:before {
        position: absolute;
        top: 17px;
        left: 15px;
        content: '';
        width: 6px;
        height: 22px;
        background-color: #f9aa0d;
      }

      span {
        font-size: 16px;
        font-weight: normal;
        letter-spacing: 0px;
        color: #999999;
      }

      p {
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;

        b {
          color: #c70005;
        }
      }
    }
    .form-step {
      padding: 20px 40px;

      span {
        width: 180px;
        height: 42px;
        text-align: center;
        line-height: 42px;
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #999999;
        background-color: #e8e8e8;
        border-radius: 21px;
        cursor: pointer;
        &.active {
          background-color: #f9aa0d;
          color: #fff;
        }
      }
    }

    .step-box {
      .xy-box {
        display: flex;
        flex-direction: column;
        border-radius: 4px;
        border: solid 1px #DCDFE6;
        .xy-item {
          padding: 8px 24px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          &.active {
            border-bottom: solid 1px #DCDFE6;
          }
        }
      }
      .operate {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin: 0 20px;
        padding-bottom: 40px;
        .operate-submit {
          width: 150px;
          height: 60px;
          background-color: #0087d4;
          border-radius: 30px;
          font-size: 16px;
          line-height: 30px;
          color: #ffffff;
        }
        .operate-next {
          width: 314px;
          height: 60px;
          margin-left: 50px;
          background-image: linear-gradient(90deg,
            #f9aa0d 0%,
            #e44730 100%),
          linear-gradient(
              #f9aa0d,
              #f9aa0d);
          background-blend-mode: normal,
          normal;
          border-radius: 30px;
          font-size: 16px;
          line-height: 30px;
          color: #ffffff;
        }
      }
      .file-container {
        display: flex;
        flex-direction: row;
        height: 185px;
        border: 1px solid #eeeeee;
        align-items: center;
        .file-box{
          display: block;
          width: 131px;
          height: 131px;
        }
        .file-title {
          width: 200px;
          font-size: 16px;
          text-align: right;
          span {
            color: red;
          }
        }
        .file-up {
          flex-shrink: 0;
          width: 131px;
          height: 131px;
          margin-left: 14px;
        }
        .file-img-container {
          margin-left: 14px;
          position: relative;
          i {
            font-size: 26px;
            color: #f9aa0d;
            position: absolute;
            top: -15px;
            right: -15px;
            cursor: pointer;
          }
          .file-img {
            width: 183px;
            height: 130px;
          }
        }

      }
      .file-box {
        display: flex;
        flex-direction: row;
        .file-container {
          display: flex;
          flex-direction: row;
          height: 185px;
          border: 1px solid #eeeeee;
          align-items: center;
          flex: 1;
          .file-title {
            width: 200px;
            font-size: 16px;
            text-align: right;
            span {
              color: red;
            }
          }
          .file-up {
            flex-shrink: 0;
            width: 131px;
            height: 131px;
            margin-left: 14px;
          }
          .file-img-container {
            margin-left: 14px;
            position: relative;
            i {
              font-size: 26px;
              color: #f9aa0d;
              position: absolute;
              top: -15px;
              right: -15px;
              cursor: pointer;
            }
            .file-img {
              width: 183px;
              height: 130px;
            }
          }

        }
      }
      .file-tip {
        width: 100%;
        height: 50px;
        font-size: 16px;
        line-height: 50px;
        padding-left: 36px;
        background-color: #ffe6e7;
        margin-top: 20px;
      }
      .input-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        min-height: 42px;
        &.active {
          border-radius: 4px;
          border: 1px solid #DCDFE6;
          padding: 0 12px;
        }
        .input-type {
          width: 120px;
          height: 27px;
        }
        span {
          margin-right: 20px;
          flex-shrink: 0;
        }
      }
      .step-title {
        .step-title-text {
          width: 179px;
          height: 35px;
          text-align: center;
          line-height: 35px;
          font-size: 18px;
          font-weight: normal;
          font-style: italic;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #ffffff;
          background: url(../../assets/img/title.png) no-repeat center;
        }
        .step-title-tips {
          flex: 1;
          padding: 10px;
          line-height: 16px;
          font-size: 12px;
          background-color: #fff4f4;
          border-radius: 4px;
          border: solid 1px #ffe8e8;
          color: #c70005;
          span {
            color: #999;
          }
        }
      }
      .demeanour-item {
        margin-bottom: 30px;
        padding: 20px 20px 10px;
        border: 1px solid #c70005;
        border-radius: 5px;

        div {
          //display: flex;
          //align-items: self-start;
          margin-bottom: 5px;

          span {
            display: block;
            width: 80px;
            line-height: 24px;

            b {
              padding: 0 14px;
            }
          }

          p {
            flex: 1;
            line-height: 24px;
          }

          img {
            flex: 1;
            display: block;
            width: auto;
            max-width: 100%;
            height: 200px;
            margin: 0 auto;
          }
        }

        .demeanour-item-btn {
          margin-top: 15px;
          display: flex;
          align-items: center;
          justify-content: space-around;
        }
      }
      .promise {
        width: 800px;
        margin: 30px auto 0;
        padding-left: 50px;

        p {
          line-height: 40px;
          font-size: 16px;
          font-weight: 500;
          margin-top: 10px;
          padding-left: 200px;
        }
      }
    }
  }

</style>
